import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $paymentsByRecipientId } from '@lib/store';
import { useListState } from '@shared/hooks';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import { RecipientTable } from './recipientTable';

interface RecipientTransactionProps {
  recipient: RecipientResponse;
}

export const RecipientTransaction = (props: RecipientTransactionProps) => {
  const paymentsByRecipientId = useUnit($paymentsByRecipientId.store);

  const recipientTransactionsState = useListState({ list: 'recipientTransactions' });

  useEffect(() => {
    if (!props.recipient.id) return;
    $paymentsByRecipientId.events.update({
      RecipientId: props.recipient.id,
      Count: recipientTransactionsState.count,
      FromIndex: recipientTransactionsState.fromIndex,
    });
  }, [props.recipient?.id, recipientTransactionsState]);

  return (
    <RecipientTable
      isLoading={paymentsByRecipientId.loading}
      data={paymentsByRecipientId.data?.data}
      totalItemCount={paymentsByRecipientId.data.total}
      currentPage={recipientTransactionsState.page}
      countItemPage={recipientTransactionsState.count}
      onChangePage={recipientTransactionsState.onChangePage}
      onChangeCountItemPage={recipientTransactionsState.onChangeCount}
    />
  );
};
